import RTIPrint from "../components/RTIPrint";
import React, { useEffect, useState } from "react";
import ReactDOM from 'react-dom';
import { useNavigate } from "react-router-dom";
const API_URL = process.env.REACT_APP_API_URL;
const RTIList = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [deleteId, setDeleteId] = useState(null);
  const [selectedReceipt, setSelectedReceipt] = useState(null);
  const [successMessage, setSuccessMessage] = useState("");

const fetchRTI = async () => {
  try {
    const res = await fetch(`${API_URL}/api/rti`);
    const result = await res.json();

    if (Array.isArray(result)) {
      const sortedData = [...result].sort((a, b) =>
        b.receipt_no.localeCompare(a.receipt_no)
      );

      setData(sortedData);
    } else {
      setData([]);
    }
  } catch (err) {
    console.error("Failed to fetch RTI data", err);
  }
};

  useEffect(() => {
    fetchRTI();
  }, []);

  const confirmDelete = async () => {
    await fetch(`${API_URL}/api/rti/${deleteId}`, { method: "DELETE" });
    setDeleteId(null);
    fetchRTI();
    setSuccessMessage("Receipt deleted successfully ✅");
  };

  // CSV Export - Oldest First (Opposite of Table)
  const exportToCSV = () => {
    // Reverse the data so oldest comes first
    const reversedData = [...data].reverse();

    const headers = [
      "Sr No", "Receipt No", "Date", "Payee Name", "Amount", "Amount in Words",
      "Description", "Payment Mode", "Reference No", "Reference Date",
      "Bank Name", "Branch Name", "Remark"
    ];

    const rows = reversedData.map((r, index) => [
      index + 1,
      r.receipt_no || "",
      r.receipt_date?.slice(0, 10) || "",
      r.payee_name || "",
      r.amount || "",
      r.amount_words || "",
      r.description || "",
      r.payment_mode || "",
      r.reference_no || "",
      r.reference_date ? r.reference_date.slice(0, 10) : "",
      r.bank_name || "",
      r.branch_name || "",
      r.remark || ""
    ]);

    const csvContent = [
      headers.join(","),
      ...rows.map(row => row.map(field => `"${field}"`).join(","))
    ].join("\n");

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);
    link.href = url;
    link.download = `RTI_List_${new Date().toISOString().slice(0,10)}.csv`;
    link.click();
    URL.revokeObjectURL(url);
  };

  return (
    <div className="pt-6 pb-8 max-w-7xl mx-auto">

      {/* HEADER */}
      <div className="bg-gradient-to-r from-blue-600 to-blue-500 text-white rounded-2xl p-6 shadow mb-6 flex justify-between items-center">
        <div>
          <h2 className="text-2xl font-semibold">RTI List</h2>
          <p className="text-sm opacity-90 mt-1">Manage RTI receipts and details</p>
        </div>

        <button
          onClick={exportToCSV}
          className="px-6 py-3 bg-white text-blue-700 font-semibold rounded-2xl hover:bg-blue-50 transition flex items-center gap-2 shadow"
        >
          Export to CSV
        </button>
      </div>

      {/* TABLE */}
      <div className="bg-white rounded-2xl shadow p-6">
        <div className="overflow-x-auto">
          <table className="w-full text-sm">

            <thead className="bg-blue-600 text-white sticky top-0">
              <tr>
                <th className="px-4 py-4 text-left font-medium">Actions</th>
                <th className="px-4 py-4 text-left font-medium">#</th>
                <th className="px-4 py-4 text-left font-medium">Receipt No</th>
                <th className="px-4 py-4 text-left font-medium">Date</th>
                <th className="px-4 py-4 text-left font-medium">Payee Name</th>
                <th className="px-4 py-4 text-left font-medium">Amount</th>
                <th className="px-4 py-4 text-left font-medium">Amount in Words</th>
                <th className="px-4 py-4 text-left font-medium">Description</th>
                <th className="px-4 py-4 text-left font-medium">Payment Mode</th>
                <th className="px-4 py-4 text-left font-medium">Reference No</th>
                <th className="px-4 py-4 text-left font-medium">Reference Date</th>
                <th className="px-4 py-4 text-left font-medium">Bank Name</th>
                <th className="px-4 py-4 text-left font-medium">Branch Name</th>
                <th className="px-4 py-4 text-left font-medium">Remark</th>
              </tr>
            </thead>

            <tbody className="divide-y divide-gray-100">
              {data.map((r, index) => (
                <tr key={r.id} className="hover:bg-blue-50/60 transition">
<td className="px-4 py-4">
  <div className="relative group">
    <button className="px-4 py-2 text-xs font-medium rounded-lg bg-gray-100 hover:bg-gray-200 text-gray-700 transition flex items-center gap-1">
      Actions ▾
    </button>
    <div className="absolute left-0 top-8 hidden group-hover:block bg-white border border-gray-200 rounded-xl shadow-lg z-50 w-44 overflow-hidden">
      <button
        onClick={() => navigate(`/rti-edit/${r.id}`, { state: { record: r } })}
        className="w-full text-left px-4 py-2.5 text-sm text-gray-700 hover:bg-blue-50 hover:text-blue-600 transition"
      >
        Edit
      </button>
      <button
        onClick={() => setDeleteId(r.id)}
        className="w-full text-left px-4 py-2.5 text-sm text-gray-700 hover:bg-red-50 hover:text-red-600 transition"
      >
        Delete
      </button>
      <button
        onClick={() => setSelectedReceipt({ ...r, mode: "EN" })}
        className="w-full text-left px-4 py-2.5 text-sm text-gray-700 hover:bg-green-50 hover:text-green-600 transition"
      >
        Print English Receipt
      </button>
      <button
        onClick={() => setSelectedReceipt({ ...r, mode: "MR" })}
        className="w-full text-left px-4 py-2.5 text-sm text-gray-700 hover:bg-purple-50 hover:text-purple-600 transition"
      >
        Print Marathi Receipt 
      </button>
    </div>
  </div>
</td>

                  <td className="px-4 py-4 text-gray-600 font-medium">{index + 1}</td>
                  <td className="px-4 py-4 font-medium text-gray-800">{r.receipt_no}</td>
                  <td className="px-4 py-4 text-gray-700">{r.receipt_date?.slice(0, 10)}</td>
                  <td className="px-4 py-4 text-gray-700">{r.payee_name}</td>
                  <td className="px-4 py-4 text-gray-700 font-medium">₹ {r.amount}</td>
                  <td className="px-4 py-4 text-gray-600 text-sm">{r.amount_words}</td>
                  <td className="px-4 py-4 text-gray-600 text-sm max-w-xs truncate" title={r.description}>
                    {r.description || "-"}
                  </td>
                  <td className="px-4 py-4 text-gray-700">{r.payment_mode}</td>
                  <td className="px-4 py-4 text-gray-700">{r.reference_no || "-"}</td>
                  <td className="px-4 py-4 text-gray-700">
                    {r.reference_date ? r.reference_date.slice(0, 10) : "-"}
                  </td>
                  <td className="px-4 py-4 text-gray-700">{r.bank_name || "-"}</td>
                  <td className="px-4 py-4 text-gray-700">{r.branch_name || "-"}</td>
                  <td className="px-4 py-4 text-gray-600 text-sm max-w-xs truncate" title={r.remark}>
                    {r.remark || "-"}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Delete Modal */}
      {deleteId && (
        <div className="fixed inset-0 bg-black/40 backdrop-blur-sm flex items-center justify-center z-50">
          <div className="bg-white rounded-2xl shadow-xl w-full max-w-sm p-6 space-y-4">
            <h2 className="text-lg font-semibold text-gray-800">Delete Receipt</h2>
            <p className="text-sm text-gray-600">Are you sure you want to delete this receipt? This action cannot be undone.</p>
            <div className="flex justify-end gap-3 pt-4">
              <button onClick={() => setDeleteId(null)} className="px-6 py-2.5 bg-gray-200 rounded-2xl hover:bg-gray-300 transition font-medium">Cancel</button>
              <button onClick={confirmDelete} className="px-6 py-2.5 bg-red-600 text-white rounded-2xl hover:bg-red-700 transition font-medium">Yes, Delete</button>
            </div>
          </div>
        </div>
      )}

      {/* Success Modal */}
      {successMessage && (
        <div className="fixed inset-0 bg-black/40 backdrop-blur-sm flex items-center justify-center z-50">
          <div className="bg-white rounded-2xl shadow-xl w-full max-w-sm p-8 text-center">
            <div className="text-5xl mb-4">✅</div>
            <h2 className="text-xl font-semibold mb-2">Success</h2>
            <p className="text-gray-600 mb-6">{successMessage}</p>
            <button onClick={() => setSuccessMessage("")} className="px-8 py-3 bg-green-600 text-white rounded-2xl hover:bg-green-700 transition font-medium">OK</button>
          </div>
        </div>
      )}

      {/* Print Component */}
      {selectedReceipt && ReactDOM.createPortal(
        <RTIPrint data={selectedReceipt} onClose={() => setSelectedReceipt(null)} />,
        document.getElementById('print-root')
      )}
    </div>
  );
};

export default RTIList;